import { clutch } from "@/shared/utils/number/number";

export const linear = (timeFraction) => {
  return timeFraction;
};

export const animate = ({
  timing = linear,
  draw,
  duration,
  onEnd,
}) => {
  const start = performance.now();
  let stopped = false;

  requestAnimationFrame(function animate(time) {
    if (!stopped) {
      let timeDelta = clutch(time - start, 0, duration);
      let timeFraction = timeDelta / duration;

      const progress = timing(timeFraction);

      draw(timeDelta, progress);

      if (timeFraction < 1) {
        requestAnimationFrame(animate);
      } else {
        if (onEnd) {
          onEnd();
        }
      }
    }
  });

  return {
    stop: () => {
      stopped = true;
    }
  };
};
